import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';

/* Mismos colores que los tomos en la imagen del pack */
const TOMO_COLORS = ['bg-blue-600 text-white', 'bg-orange-500 text-white', 'bg-green-600 text-white', 'bg-red-600 text-white', 'bg-purple-600 text-white', 'bg-teal-600 text-white'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-ciencia-light text-noche-dark" data-id="element-146" data-mp="12hxds2zlm27">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-147" data-mp="3t7vi142gnhky">
        <p className="inline-block rounded-md bg-noche px-2 py-0.5 font-sub text-sm font-extrabold leading-tight text-oro" data-id="element-148" data-mp="atcjmwg8glnn">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-2 font-display text-[1.45rem] uppercase leading-[1.1] text-noche sm:text-4xl" data-id="element-149" data-mp="ktmzypxke971">
          <span className="bg-noche px-1.5 text-oro" data-id="element-150" data-mp="frnth76j2w5v">6 tomos en un solo sistema,</span>{' '}
          creados para enseñar, estudiar y practicar de forma organizada.
        </h2>
        <p className="mt-1.5 font-sub text-xs font-extrabold uppercase leading-tight text-ciencia sm:text-sm" data-id="element-151" data-mp="3b9yyqtdgr9h3">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-noche-dark/80" data-id="element-152" data-mp="3kaws8hq9zylf">
          No es simplemente otro ebook educativo. Es un{' '}
          <strong className="font-bold text-noche" data-id="element-153" data-mp="3p981orcns734">
            sistema de aprendizaje y recursos didácticos
          </strong>{' '}
          que reúne explicaciones, ejemplos, actividades, análisis literarios,
          ejercicios y herramientas para planificar y evaluar, todo organizado
          para facilitar el trabajo en secundaria.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-154" data-mp="bv3lgulqy1hk">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-xl border-2 border-noche bg-white text-left" data-id="element-155" data-mp="gt55bhqzy4u3" data-mpi={i}>
              <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-0.5 ${TOMO_COLORS[i]}`} data-id="element-156" data-mp="27yrnt703a5w4">
                <span className="font-sub text-[10px] font-extrabold uppercase tracking-wider" data-id="element-157" data-mp="2hvw974m41xbv">
                  Tomo
                </span>
                <span className="font-display text-3xl leading-none" data-id="element-158" data-mp="2vm9jhdmh5o4d">
                  {i + 1}
                </span>
              </span>
              <div className="p-2.5" data-id="element-159" data-mp="2rns7ogs3zpgm">
                <h3 className="font-sub text-sm font-extrabold leading-tight text-noche" data-id="element-160" data-mp="35m0c19rh5t1t">
                  <span className="sr-only" data-id="element-161" data-mp="30mnhs3y9xjp7">Tomo {i + 1} — </span>
                  {tomo.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-noche-dark/80 sm:text-sm" data-id="element-162" data-mp="1b6o1m2w8mu02">
                  {tomo.desc}
                </p>
              </div>
            </Reveal>)}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-163" data-mp="3hwrbux4do9xl">
          🚀 Sí, quiero acceder ahora
        </CtaButton>
      </div>
    </section>;
}